export const ICON_LIBRARY_TITLE = 'Icon Library';

export const ICON_LIBRARY_LABELS = {
  FONTAWESOME: 'FontAwesome',
  MICROSOFT_ICONS: 'Microsoft Icons',
  TED_CAREERS_ICONS: 'TED and Careers Icons',
  ADOBE_ICONS: 'Adobe Icons',
  GRAPHING_CALCULATOR_ICONS: 'Graphing Calculator Icons',
  MATH_STATS_ICONS: 'Math and Stats Icons',
  B_AND_E: 'B&E Icons',
  ECS_LIBRARY: 'ECS Library',
  CRX: 'CRX Icons',
  CPA_ICONS: 'CPA Icons',
};

export const ICON_LIBRARY_STATUS = {
  SELECTED: 'SELECTED',
  NOT_SELECTED: 'NOT_SELECTED',
};

export const ICON_LIBRARY_LIST = Object.freeze([
  {
    name: ICON_LIBRARY_LABELS.FONTAWESOME,
    status: ICON_LIBRARY_STATUS.SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.MICROSOFT_ICONS,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.TED_CAREERS_ICONS,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.ADOBE_ICONS,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.GRAPHING_CALCULATOR_ICONS,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.MATH_STATS_ICONS,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.B_AND_E,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.ECS_LIBRARY,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.CRX,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
  {
    name: ICON_LIBRARY_LABELS.CPA_ICONS,
    status: ICON_LIBRARY_STATUS.NOT_SELECTED,
  },
]);

export const MICROSOFT_ICONS_WARNING = "Microsoft icons in this Bronte library are permitted for use in IT/MIS products only. Any other usage of these specific icons violates Microsoft's Terms of Use policies.";
export const ADOBE_ICONS_WARNING = "Adobe icons in this Bronte library are permitted for use in Adobe titles from ITP Group only. Any other usage of these specific icons violates Adobe's Terms of Use policies.";